import RtReconciliationUploadRtReportErrorBase from './base/RtReconciliationUploadRtReportErrorBase';

/**
 * @class RtReconciliationUploadRtReportError
 * @extends RtReconciliationUploadRtReportErrorBase
 */
class RtReconciliationUploadRtReportError extends RtReconciliationUploadRtReportErrorBase {

}

export default RtReconciliationUploadRtReportError;
